export const certificateTitles = (type) => {
  if (type === 1) {
    return {
      a: "মেধা কর্মের শিরোনাম / Title of the Intellectual Work",
      b: "মেধা কর্মের প্রণেতা / Author of The Intellectual Work",
      c: "মেধা কর্মের স্বত্বাধিকারী / Owner of the Intellectual Work",
      c2: "স্বত্বের অংশ / Proportion",
      c3: "Owner of the work",
      d: "মেধা কর্মের ক্ষেত্র / Field of the Work",
    };
  } else if (type === 2) {
    return {
      a: "Title of Work",
      b: "Name of Licensee",
      c: "Creator of the Work",
      d: "Field of Copyright",
    };
  } else if (type === 3) {
    return {
      a: "মেধা কর্মের শিরোনাম / Title of the Intellectual Work",
      b: "মেধা কর্মের প্রণেতা / Author of The Intellectual Work",
      c: "মেধা কর্মের সম্পৃক্ত অধিকারের স্বত্বাধিকারী / Owner of Related Right of the Intellectual Work",
      c2: "অধিকারের ধরন / Type of Right",
      c3: "Owner of Related work",
      d: "মেধা কর্মের ক্ষেত্র / Field of the Work",
    };
  } else {
    // type === 4
    return {
      a: "সৃজনশীল মেধা কর্মের শিরোনাম / Title of Creative Intellectual Work",
      b: "সৃজনশীল কর্মের প্রনেতা / Author of the Creative Work",
      c: "সম্প্রচারকারী (সম্প্রচারের মাধ্যম) / Broadcaster (Broadcasting Medium)",
      d: "সৃজনশীল কর্মের - শ্রেণী (উপশ্রেণী) / Creative Work - Category (Subcategory)",
    };
  }
};
